import { getApiUrl, API_URL } from '@/utils/api';
import ApiBase from './ApiBase';

export default class CustomizationService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.ADMIN, '/config');

  getCustomizationPrice(storeId: string) {
    return this.api.getJSON(`${CustomizationService.baseUrl}/bykeyandstore?key=CUSTOMIZATION_PRICE&storeId=${storeId}`);
  }
}
